/**
 * What a "Szybki feedback" card looks like WAITING — the short Talia card's own box and its parts'
 * boxes, so the card that lands replaces bars of its own shape (`src/shared/AGENTS.md`: a skeleton
 * in the shape of the content). Drawn in the session card's shape, the commonest and the tallest of
 * the four kinds on the Pulpit.
 *
 * Beside the card it reserves, because the reserve has to be the shape of the answer and the shape
 * is this folder's (the same reason `FeedbackRowReserve` stood beside the rows it replaced).
 */

import skel from '~/shared/ui/skeleton.module.css';

import styles from './taliaCard.module.css';

export function TaskTaliaCardReserve({ skeleton }: { readonly skeleton: boolean }) {
  const bar = skeleton ? String(skel.bar) : '';
  return (
    <div className={`${String(styles.card)} ${String(styles.short)}`} aria-hidden="true">
      <div className={styles.head}>
        <span className={`${String(styles.holeAvatar)} ${bar} ${skeleton ? String(skel.disc) : ''}`} />
        <span className={styles.who}>
          <i className={`${String(styles.holeName)} ${bar}`} />
          <i className={`${String(styles.holeKind)} ${bar}`} />
        </span>
      </div>
      <div className={styles.body}>
        <i className={`${String(styles.holeVisual)} ${bar}`} />
      </div>
      <div className={styles.foot}>
        <i className={`${String(styles.holeFoot)} ${bar}`} />
      </div>
    </div>
  );
}
